import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-loader-store',
  templateUrl: './loader-store.component.html',
  styleUrls: ['./loader-store.component.css']
})
export class LoaderStoreComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
